import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/option-item/option-item.component.js'

const tagName = 'dap-ds-option-item'

/**
 * `dap-ds-option-item`
 * @summary An option item is a selectable item in a list of options.
 * @element dap-ds-option-item
 * @title - Option item
 * @group select,combobox
 * *
 * @csspart base - The main option item container.
 * @csspart prefix - The prefix of the option item.
 * @csspart label - The label of the option item.
 * @csspart suffix - The suffix of the option item.
 *
 * @slot prefix - The prefix of the option item.
 * @slot - The label of the option item.
 * @slot suffix - The suffix of the option item.
 *
 * @cssproperty --dds-option-item-padding-vertical - The vertical padding of the option item (default: var(--dds-spacing-100))
 * @cssproperty --dds-option-item-padding-horizontal - The horizontal padding of the option item (default: var(--dds-spacing-200))
 * @cssproperty --dds-option-item-border-radius - The border radius of the option item (default: var(--dds-radius-small, 4px))
 * @cssproperty --dds-option-item-color - The text color of the option item (default: var(--dds-text-neutral-base))
 * @cssproperty --dds-option-item-hover-bg - The background color of the option item when hovered (default: var(--dds-background-neutral-medium))
 * @cssproperty --dds-option-item-active-bg - The background color of the option item when active (default: var(--dds-background-neutral-strong))
 * @cssproperty --dds-option-item-disabled-color - The text color of the option item when disabled (default: var(--dds-text-neutral-disabled))
 * @cssproperty --dds-option-item-high-contrast-border - The border color of the option item in high contrast mode (default: var(--dds-border-neutral-transparent-interactive, #fff500))
 * @cssproperty --dds-option-item-selected-font-weight - The font weight of the option item when selected (default: var(--dds-font-weight-bold))
 * @cssproperty --dds-option-item-xs-font-size - The font size of the option item in extra small size (default: var(--dds-font-sm))
 * @cssproperty --dds-option-item-lg-font-size - The font size of the option item in large size (default: var(--dds-font-lg))
 * @cssproperty --dds-option-item-selected-icon-width - The width of the selected icon (default: var(--dds-spacing-400))
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSOptionItem',
})

export default reactWrapper
